/**
 * Prompt-title markdown — the ONE piece of markup executive prompt titles support: **bold**.
 *
 * Trinity authors write titles in the Library manager and wrap the entities an executive should notice in double
 * asterisks ("What is the impact of increasing **Zejula share** on **revenue**?" — Sidd's ask, ruled 2026-09-07).
 * Every surface that shows a title renders it through `renderPromptTitle`, which turns the markup into <strong>
 * spans built as React elements — no HTML string is ever injected, and nothing but the bold marker is parsed.
 * Contexts that cannot carry markup (headlines that are already bold, aria-labels, confirm-dialog copy) use
 * `stripPromptMarkdown` and show the plain words.
 *
 * Unbalanced or empty markers are left literal, so a typo can never swallow text.
 */
import React from 'react';

const BOLD_RE = /\*\*(.+?)\*\*/g;

export const PROMPT_TITLE_BOLD_HELP =
  'To bold words for executives, wrap them in double asterisks: **Net Revenue** by segment.';

export const stripPromptMarkdown = (title: string): string =>
  title.replace(BOLD_RE, '$1');

export const renderPromptTitle = (title: string): React.ReactNode => {
  if (!title.includes('**')) return title;
  const re = new RegExp(BOLD_RE.source, 'g');
  const parts: React.ReactNode[] = [];
  let last = 0;
  let match: RegExpExecArray | null = re.exec(title);
  while (match) {
    if (match.index > last) parts.push(title.slice(last, match.index));
    parts.push(<strong key={match.index}>{match[1]}</strong>);
    last = match.index + match[0].length;
    match = re.exec(title);
  }
  if (last < title.length) parts.push(title.slice(last));
  return <>{parts}</>;
};
